import { z } from 'zod';

export enum TeamMemberRole {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
}

export const TeamMemberRoleSchema = z.nativeEnum(TeamMemberRole);
